import React from 'react';
import useTranslation from '../../Hooks/useTranslation';
import { FieldError } from 'react-hook-form';
import * as yup from 'yup';
import moment from 'moment';

export const yupMoment = (validationMessage: string, nullable: boolean = false) => yup.mixed().test(
	'is-moment',
	validationMessage,
	value => moment.isMoment(value) || (nullable ? (value === null || value === undefined) : false)
);

export const useValidation = () => {
	const { t } = useTranslation();

	const messageFilled = (controlLabel: string) => {
		return controlLabel;
	};

	const fillErrorMessage = (error?: FieldError): string => {
		if (!error) {
			return '';
		}

		if (
			['is-required-select', 'required'].indexOf(error.type) !== -1 &&
			typeof error.message !== 'undefined'
		) {
			return messageFilled(t(error.message) ?? '');
		}
		return t(error.message);
	};

	const messageNumber = (controlLabel: string) => {
		return t('base.shared.form.validation.number').replace(
			'%label',
			controlLabel,
		);
	};

	return {
		messageFilled,
		messageNumber,
		fillErrorMessage,
	};
};
